var render = function render(){var _vm=this,_c=_vm._self._c;return _c('error-component',{attrs:{"code":_vm.code}})
}
var staticRenderFns = []

export { render, staticRenderFns }